import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VesselMachinery } from '../dto/vessel-machinery';

@Injectable({
  providedIn: 'root'
})
export class VesselMachineryService {

  private apiUrl = environment.apiRoot + '/vesselmachinery';

  constructor(private http: HttpClient) { }

  getAllMachineriesOfVessel(vesselId: number): Observable<VesselMachinery[]> {
    return this.http.get<VesselMachinery[]>(this.apiUrl + '/allofvessel?vesselId=' + vesselId);
  }

  createMachinery(vesselId: number): Observable<VesselMachinery> {
    let model = { "id": 0, "vessel_id": vesselId, "name": "new Machinery" };
    return this.http.post<VesselMachinery>(this.apiUrl + '/new', model);
  }

  updateMachinery(model: VesselMachinery): Observable<VesselMachinery> {
    return this.http.put<VesselMachinery>(this.apiUrl + '/update', model);
  }

  deleteMachinery(machineryId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?machineryId=' + machineryId);
  }

}
